<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
    >
      <div slot="name" class="title-size font-bold text-gray-500 text-center">
        Nombre completo del CF
      </div>
      <div
        slot="identification_type_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Tipo de identificación
      </div>
      <div
        slot="identification_number"
        class="title-size font-bold text-gray-500 text-center"
      >
        Número de identificación
      </div>
      <div slot="email" class="title-size font-bold text-gray-500 text-center">
        Correo electrónico
      </div>
      <div slot="creation_date" class="title-size font-bold text-gray-500">
        Fecha de creación
      </div>

      <!-- Custom rendering for type_problem_name column -->
      <template slot="type_problem_name" slot-scope="text, record">
        <SupportTypeProblemLabel :label="record.type_problem_name" />
      </template>

      <div slot="type_problem_name" class="title-size font-bold text-gray-500">
        Tipo de problema
      </div>

      <!-- Custom rendering for status column -->
      <template slot="status" slot-scope="text, record">
        <SupportStatusLabel :status="record.status" />
      </template>

      <div slot="status" class="title-size font-bold text-gray-500 text-center">
        Estado
      </div>
      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div slot="actions" slot-scope="text, record">
        <button
          class="flex justify-center col-span-4 text-xs mx-auto text-blue h-min"
          @click="supportDetail(record)"
        >
          <a-icon
            type="eye"
            theme="twoTone"
            two-tone-color="#3366cc"
            :style="{
              fontSize: '20px',
            }"
          />
          <b class="my-auto ml-2">Ver</b>
        </button>
      </div>
    </a-table>
  </div>
</template>

<script>
import SupportStatusLabel from "../partials/SupportStatusLabel.vue";
import SupportTypeProblemLabel from "../partials/SupportTypeProblemLabel.vue";
const columns = [
  {
    slots: { title: "name" },
    dataIndex: "name",
    key: "name",
    width: 180,
  },
  {
    slots: { title: "identification_type_name" },
    dataIndex: "identification_type_name",
    key: "identification_type_name",
    width: 180,
  },
  {
    slots: { title: "identification_number" },
    dataIndex: "identification_number",
    key: "identification_number",
    width: 150,
  },
  {
    slots: { title: "email" },
    dataIndex: "email",
    key: "email",
    width: 190,
  },
  {
    slots: { title: "creation_date" },
    dataIndex: "creation_date",
    key: "creation_date",
    width: 120,
  },
  {
    slots: { title: "type_problem_name" },
    dataIndex: "type_problem_name",
    key: "type_problem_name",
    scopedSlots: { customRender: "type_problem_name" }, // Enable custom rendering
    width: 160,
  },
  {
    slots: { title: "status" },
    dataIndex: "status",
    key: "status",
    scopedSlots: { customRender: "status" }, // Enable custom rendering
    width: 100,
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 100,
  },
];

export default {
  components: {
    SupportStatusLabel,
    SupportTypeProblemLabel,
  },
  props: ["dataSource"],
  data() {
    return {
      columns,
    };
  },
  methods: {
    supportDetail(record) {
      this.$router.push(`/dashboard/users/technical-support/${record.id}`);
    },
  },
};
</script>
